module.exports = __webpack_public_path__ + "img/Logo-Fasor_preto.4563db06.png";